import { MBIconV2Name } from '@shared/components/image';
import { TagComponent } from '../../config';
import { FieldOption } from './FieldOption';

export class TagFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<TagComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    reservedIds: Array<string>,
  ): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    return (
      !isReserved &&
      component.type === 'TAG' &&
      !!(component as TagComponent).multiselect === !!this.component.multiselect
    );
  }

  canBeAdded(_components: MBAPI.WorkflowTemplate_components[]): boolean {
    return true;
  }
}
